import httpClient from "./client";

export const getDashboardOverview = async () => {
  const response = await httpClient.get("/dashboard/overview");
  return response;
};
